import {
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxLoadPanelComponent,
  DxPopupComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import CustomStore from 'devextreme/data/custom_store';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import {
  DxiDataGridItemComponent,
  DxoDataGridSelectionComponent,
  DxoDataGridToolbarComponent,
} from 'devextreme-angular/ui/data-grid';
import { PopupBarCodeComponent } from '../../popups/popup-barcode/popup-barcode.component';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-grid-archivio-articoli',
  templateUrl: './grid-archivio-articoli.component.html',
  styleUrls: ['./grid-archivio-articoli.component.scss'],
  imports: [
    DxDataGridComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoHeaderFilterComponent,
    DxoEditingComponent,
    DxoFilterRowComponent,
    DxoExportComponent,
    DxoColumnChooserComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoLookupComponent,
    DxTemplateDirective,
    DxoDataGridSelectionComponent,
    DxoDataGridToolbarComponent,
    DxiDataGridItemComponent,
    DxButtonComponent,
    DxLoadPanelComponent,
    DxPopupComponent,
    PopupBarCodeComponent,
    DxoExportComponent,
    DxiButtonComponent
  ],
})
export class GridArchivioArticoliComponent
  extends GestArticoliBaseComponent
  implements OnChanges
{
  private navService = inject(NavigatorService);
  private tipiArticoliS = inject(TipiArticoliService);
  private articoliService = inject(ArticoliService);
  @ViewChild('gridArticoli', { static: false }) dataGrid!: DxDataGridComponent;
  @Input() idCategoria: number = 0;
  @Input() artAttivi: boolean = true;
  @Input() listArticoli: any;

  dataSource: any;
  columnResizingMode = 'widget';

  listTipiArticoli: any;

  filterValue: boolean = true;

  visibleLoadPanel: boolean = false;
  popupInfoBarCode: boolean = false;
  printBarcodeModel: PrintBarCodeModel = new PrintBarCodeModel();
  contentReadyEseguito: boolean = false;

  constructor() {
    super();
    this.loadLookup();
  }

  // async ngOnChanges(changes: SimpleChanges): Promise<void> {
  ngOnChanges(changes: SimpleChanges) {
    const categoriaChanged =
      changes['idCategoria'] &&
      changes['idCategoria'].currentValue !==
        changes['idCategoria'].previousValue;

    const listChanged =
      changes['listArticoli'] &&
      changes['listArticoli'].currentValue !==
        changes['listArticoli'].previousValue;

    const attiviChanged =
      changes['artAttivi'] &&
      changes['artAttivi'].currentValue !== changes['artAttivi'].previousValue;

    if (attiviChanged) {
      this.filterByCategory(this.idCategoria);
    }
    if (listChanged) {
      this.loadArticoli();
    }

    if (this.idCategoria >= 0 && categoriaChanged) {
      this.filterByCategory(this.idCategoria);
    }
  }

  loadLookup() {
    //Tipi Articoli
    this.tipiArticoliS.getListTipiArticoliTemp().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'warning');
        }
      },
    });
  }

  loadArticoli() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        if (this.listTipiArticoli != undefined) {
          this.listArticoli.forEach((art: any) => {
            const tipo = this.listTipiArticoli.find(
              (x: any) => x.id == art.idTipo,
            );
            art.immateriale = tipo.immateriale;
          });
        }
        return this.listArticoli;
      },
      remove: (key) => {
        return (
          firstValueFrom(this.articoliService.remove(key))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => {
              console.log('delete eseguito');
              this.refreshArticoli();
            })
            .catch((error: HttpErrorResponse) => {
              //throw 'Deletion failed'
              if (error?.error?.title) {
                throw error.error.title;
              } else {
                throw 'Errore cancellazione articolo';
              }
            })
        );
      },
    });
  }

  refreshArticoli(){
    this.articoliService.listTemp(true).subscribe({
      next: res=>{
        this.listArticoli = res;
        // this.listArticoli.forEach((art: any) => {
        //     const tipo = this.listTipiArticoli.find(
        //       (x: any) => x.id == art.idTipo,
        //     );
        //     art.immateriale = tipo.immateriale;
        //   });
        this.dataGrid.instance.refresh();
      },
      error: err=>{
        if(err?.error?.title){
          notificaMessaggio(err.error.title, "error");
        }
        else{
          notificaMessaggio("Errore refresh tabella articoli", "error");
        }
      }
    })
  }

  filterByCategory(catId: number) {
    this.dataGrid?.instance.clearFilter(); // Pulisco filtro grid
    if (catId && catId > 0) {
      //Filtro la grid per la categori selezionata
      if(this.artAttivi){
      this.dataGrid?.instance?.filter([['idCategoria', '=', catId], ['attivo', '=', true]]);
      }
      else{
        this.dataGrid?.instance?.filter([['idCategoria', '=', catId]]);
      }
    }  
    else if (this.artAttivi){
      this.dataGrid?.instance?.filter([['attivo', '=', this.artAttivi]]);
    } 
  }

  goToDetail(id: number) {
    this.navService.goToArticoliDashboard(id);
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        name: 'nuovo',
        class: 'success',
        onClick: this.gotoNewArticolo.bind(this),
      },
    });
  }

  onRowPrepared(e: any) {
    if (e.rowType == 'data') {
      const giacenza = e.data.giacenza;
      const scortaMinima = e.data.scortaMinima;

      if (scortaMinima == 0) {
        //NESSUNA VERIFICA
      } else if (giacenza < scortaMinima) {
        e.rowElement.style.backgroundColor = '#fff2cc'; // rosso chiaro
      } else if (giacenza <= 0) {
        e.rowElement.style.backgroundColor = '#ffcccc'; // giallo chiaro
      } else {
        e.rowElement.style.backgroundColor = ''; // nessun colore (default)
      }
    }
  }

  gotoNewArticolo() {
    this.navService.goToArticoliNew();
  }

  //Export excel
  onExporting(e: any) {
    GridExportExcel(e, 'Articoli', 'Articoli.xlsx');
  }

  /* Ordinamento lookup  */
  sortByLookup(data: any) {
    const column = this as any;
    const value = column.calculateCellValue(data);
    const ret = column.lookup.calculateCellValue(value);
    return ret;
  }

  stampaArticoli() {
    const keys = this.dataGrid.instance.getSelectedRowKeys() as number[];
    if (keys.length == 0) {
      notificaMessaggio('Selezionare almeno un articolo', 'warning');
      return;
    }
    this.printBarcodeModel.idsObject = keys;
    this.popupInfoBarCode = true;
  }

  onPopupBarcodeEventEmitter(event: any) {
    this.popupInfoBarCode = false;
    this.visibleLoadPanel = true;
    this.printBarcodeModel.grande = event.grande;
    this.printBarcodeModel.numeroCopie = event.numeroCopie;
    this.articoliService.stampaEtichette(this.printBarcodeModel).subscribe({
      next: (res) => {
        this.dataGrid.instance.deselectAll();
        this.visibleLoadPanel = false;
        const url = window.URL.createObjectURL(res);
        window.open(url);
      },
      error: (err) => {
        this.visibleLoadPanel = false;
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore stampa Etichetta', 'error');
        }
      },
    });
  }

  onContentReady(e:any){
    if(this.dataGrid != undefined && this.dataGrid.instance?.totalCount() == 0){
      return;
    }
    if(!this.contentReadyEseguito){
      this.filterByCategory(this.idCategoria);
      this.contentReadyEseguito = true;
    }
  }
}
